module.exports = __webpack_public_path__ + "img/remove-accessories.2d0bdfb3.jpg";